/* eslint-disable react-hooks/exhaustive-deps */
import {
	Toolbar,
	IconButton,
	Badge,
	Box,
	AppBar,
	Avatar,
	useMediaQuery,
	Tooltip,
	Menu,
	MenuItem,
	Typography,
	Divider,
	ListItemIcon,
} from '@mui/material';
import {
	NotificationsOutlined,
	Menu as MenuIcon,
	PersonOutlineOutlined,
	LogoutOutlined,
} from '@mui/icons-material';
//styles
import { useTheme } from '@mui/material/styles';
import BreadcrumbsComponent from './breadcrumbs.component';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { resetUser } from '../store/modules/user';
import { RootState } from '../store';
import { useNavigate } from 'react-router-dom';
import { useNotifications } from '../pages/notifications/hooks/useNotifications';
import { isEmpty } from '../utils/validators';
import { useMsal } from '@azure/msal-react';

interface IProps {
	toggleDrawer: () => void;
	drawerWidth: number;
	arrowToggle: boolean;
}

const AppBarLayout = ({ toggleDrawer, drawerWidth, arrowToggle }: IProps) => {
	const [anchorElUser, setAnchorElUser] = useState<null | HTMLElement>(null);
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const { instance } = useMsal();
	const matches = useMediaQuery(useTheme().breakpoints.down('md'));
	const user = useSelector((state: RootState) => state.users);
	const { number } = useSelector((state: RootState) => state.notifications);
	const { getPendingNotifications } = useNotifications();

	useEffect(() => getPendingNotifications(), []);

	const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
		setAnchorElUser(event.currentTarget);
	};

	const handleCloseUserMenu = () => {
		setAnchorElUser(null);
	};

	const handleCloseSession = () => {
		if (user.loginMicrosoft) {
			instance
				.logoutPopup({
					postLogoutRedirectUri: '/',
				})
				.then(() => {
					dispatch(resetUser());
					document.cookie = '';
					sessionStorage.clear();
					localStorage.clear();
					navigate('/login');
				})
				.finally(() => window.location.reload());
		} else {
			dispatch(resetUser());
			navigate('/login');
		}
	};

	return (
		<AppBar
			elevation={0}
			position="fixed"
			sx={{ boxShadow: '0px 1px 6px #00000029' }}
		>
			<Toolbar
				sx={{
					ml: { minWidth: `${drawerWidth}px` },
				}}
				style={{
					background: '#FFF',
					color: '#1C1C1E',
					height: 80,
				}}
			>
				<IconButton
					color="inherit"
					aria-label="btnOpenDrawer"
					data-testid="btnOpenDrawer"
					edge="start"
					onClick={toggleDrawer}
					sx={{ mr: 2, display: { md: 'none' } }}
				>
					<MenuIcon />
				</IconButton>

				<Box
					display={'inline-flex'}
					paddingLeft={matches ? '0px' : arrowToggle ? '100px' : '320px'}
					flexGrow={1}
				>
					<BreadcrumbsComponent />
				</Box>

				<IconButton color="inherit" onClick={() => navigate('/notificaciones')}>
					<Badge
						badgeContent={number}
						invisible={isEmpty(number)}
						color="secondary"
					>
						<NotificationsOutlined />
					</Badge>
				</IconButton>

				<Tooltip title="Opciones">
					<IconButton onClick={handleOpenUserMenu} sx={{ p: 0, ml: 3 }}>
						<Avatar alt={user.firstName} />
					</IconButton>
				</Tooltip>
				<Menu
					sx={{ mt: '52px' }}
					id="menu-appbar"
					anchorEl={anchorElUser}
					anchorOrigin={{
						vertical: 'top',
						horizontal: 'right',
					}}
					keepMounted
					transformOrigin={{
						vertical: 'top',
						horizontal: 'right',
					}}
					open={Boolean(anchorElUser)}
					onClose={handleCloseUserMenu}
					PaperProps={{
						elevation: 0,
						sx: {
							minWidth: 240,
							borderRadius: 2,
							overflow: 'visible',
							mt: 0.5,
							border: '1px solid #00000014',
							boxShadow: '0px 8px 24px rgba(0, 0, 0, 0.12)',
							'&::before': {
								content: '""',
								display: 'block',
								position: 'absolute',
								top: 0,
								right: 18,
								width: 12,
								height: 12,
								bgcolor: '#FFF',
								borderTop: '1px solid #00000014',
								borderLeft: '1px solid #00000014',
								transform: 'translateY(-50%) rotate(45deg)',
								zIndex: 0,
							},
							'& .MuiMenuItem-root': {
								py: 1.2,
								px: 2,
								gap: 1,
							},
						},
					}}
				>
					<Box
						sx={{
							display: 'flex',
							alignItems: 'center',
							gap: 1.5,
							px: 2,
							py: 1.5,
						}}
					>
						<Avatar
							alt={user.firstName}
							sx={{
								width: 40,
								height: 40,
								bgcolor: 'var(--color-primary-main)',
								fontSize: 16,
							}}
						>
							{(user.firstName?.[0] || '') + (user.lastName?.[0] || '')}
						</Avatar>
						<Box sx={{ overflow: 'hidden' }}>
							<Typography
								variant="subtitle2"
								noWrap
								sx={{ fontWeight: 600, color: '#1C1C1E' }}
							>
								{`${user.firstName} ${user.lastName}`.trim() || 'Usuario'}
							</Typography>
							<Typography
								variant="caption"
								noWrap
								sx={{ color: 'var(--color-grey-text)', display: 'block' }}
							>
								{user.email}
							</Typography>
						</Box>
					</Box>
					<Divider sx={{ my: 0.5 }} />
					<MenuItem
						onClick={() => {
							navigate('/mi-perfil', {
								state: user._id,
							});
							handleCloseUserMenu();
						}}
						sx={{
							'&:hover': {
								bgcolor: 'var(--color-primary-light)',
							},
						}}
					>
						<ListItemIcon sx={{ minWidth: 'auto !important' }}>
							<PersonOutlineOutlined
								fontSize="small"
								sx={{ color: 'var(--color-primary-main)' }}
							/>
						</ListItemIcon>
						<Typography variant="body2">Mi Perfil</Typography>
					</MenuItem>
					<MenuItem
						onClick={() => handleCloseSession()}
						sx={{
							color: 'var(--color-error-main)',
							'&:hover': {
								bgcolor: 'var(--color-error-light)',
							},
						}}
					>
						<ListItemIcon sx={{ minWidth: 'auto !important' }}>
							<LogoutOutlined
								fontSize="small"
								sx={{ color: 'var(--color-error-main)' }}
							/>
						</ListItemIcon>
						<Typography variant="body2">Cerrar Sesión</Typography>
					</MenuItem>
				</Menu>
			</Toolbar>
		</AppBar>
	);
};

export default AppBarLayout;
